(function() {
  'use strict';

  const form = document.getElementById('DrawerNewsletterForm');
  if (!form) return;

  const card = document.getElementById('DrawerNewsletterCard');
  const emailInput = document.getElementById('DrawerNewsletterEmail');
  const submitBtn = document.getElementById('DrawerNewsletterSubmit');
  const codeBtn = document.getElementById('DrawerNewsletterCodeBtn');
  const codeText = document.getElementById('DrawerNewsletterCodeText');
  const codeHint = document.getElementById('DrawerNewsletterCodeHint');
  const codeHintDefault = codeHint ? codeHint.textContent : '';
  const discountCode = card ? card.getAttribute('data-discount-code') : '';
  const confettiIcon = card ? card.querySelector('.drawer-newsletter__success-icon') : null;
  const confettiLayer = document.getElementById('DrawerNewsletterConfetti');

  function spawnConfetti() {
    if (!card || !confettiLayer) return;
    confettiLayer.innerHTML = '';

    const colors = ['#ff6b6b', '#feca57', '#48dbfb', '#1dd1a1', '#ff9ff3', '#54a0ff', '#ffd166', '#f368e0', '#ff9f43', '#00d2d3'];
    const cardRect = card.getBoundingClientRect();
    const cardHeight = card.offsetHeight || 400;

    let originX = card.offsetWidth / 2;
    let originY = 90;
    if (confettiIcon) {
      const iconRect = confettiIcon.getBoundingClientRect();
      originX = iconRect.left - cardRect.left + iconRect.width / 2;
      originY = iconRect.top - cardRect.top + iconRect.height / 2;
    }

    const pieceCount = 70;

    for (let i = 0; i < pieceCount; i++) {
      const piece = document.createElement('div');
      const isRound = Math.random() > 0.5;
      piece.className = 'drawer-newsletter__confetti-piece' + (isRound ? ' is-round' : '');

      const size = 5 + Math.random() * 6;
      piece.style.width = size + 'px';
      piece.style.height = (isRound ? size : size * 2.2) + 'px';
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.top = originY + 'px';
      piece.style.left = originX + 'px';

      const angle = Math.random() * Math.PI * 2;
      const burstDistance = 50 + Math.random() * 120;
      const burstX = Math.cos(angle) * burstDistance;
      const burstY = Math.sin(angle) * burstDistance - 30;

      const fallDistance = cardHeight * (0.5 + Math.random() * 0.5);
      const finalX = burstX + (Math.random() - 0.5) * 90;
      const finalY = burstY + fallDistance;
      const rotation = (Math.random() - 0.5) * 1080;

      piece.style.setProperty('--tx', finalX + 'px');
      piece.style.setProperty('--ty', finalY + 'px');
      piece.style.setProperty('--tr', rotation + 'deg');

      const duration = 1.5 + Math.random() * 1.5;
      const delay = Math.random() * 0.25;
      piece.style.animation = 'drawerConfettiFall ' + duration + 's cubic-bezier(0.25, 0.46, 0.45, 0.94) ' + delay + 's forwards';

      confettiLayer.appendChild(piece);
    }

    setTimeout(function() {
      confettiLayer.innerHTML = '';
    }, 3500);
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (!emailInput.value || !emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }

    submitBtn.disabled = true;

    const body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', emailInput.value);
    body.append('contact[tags]', 'prospect,newsletter');
    body.append('contact[context]', 'drawer');

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).catch(function() {
      // Non-blocking: still show the success/code step even if the request
      // is slow or the browser is offline — the tags-based subscription
      // is best-effort, same approach as the newsletter popup.
    });

    card.classList.add('is-success');
    spawnConfetti();
  });

  if (codeBtn) {
    codeBtn.addEventListener('click', function() {
      const code = codeText ? codeText.textContent.trim() : discountCode;
      if (!code) return;

      const resetHint = function() {
        if (codeHint) {
          setTimeout(function() {
            codeHint.textContent = codeHintDefault;
          }, 2000);
        }
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function() {
          if (codeHint) codeHint.textContent = 'Copied!';
          resetHint();
        }).catch(function() {});
      } else {
        // Fallback for browsers without the Clipboard API
        const tmp = document.createElement('textarea');
        tmp.value = code;
        tmp.style.position = 'fixed';
        tmp.style.opacity = '0';
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(tmp);
        if (codeHint) codeHint.textContent = 'Copied!';
        resetHint();
      }
    });
  }
})();
